import { useModalAction, useModalState } from "@/contexts/modal/Context.tsx";
import CalendarIllustration from "@/components/ui/CalendarIllustration.tsx";
import dayjs from "dayjs";
import { useMe } from "@/data/user.ts";
import { Button } from "@/components/ui/Button.tsx";
import { useBookOneToOneMutation } from "@/data/one-to-one.ts";

interface Props {
  tutor: string;
  date: string;
  hour: string;
}

export default function ConfirmOneToOneModal() {
  const { data } = useModalState();
  const { date, tutor, hour } = data as Props;
  const { closeModal } = useModalAction();
  const { me } = useMe();
  const { mutate, isLoading } = useBookOneToOneMutation(closeModal);

  const newDate = dayjs(date);

  const handleConfirm = () => {
    if (!me) return;

    if (!me) return;
    mutate({
      tutor_token: tutor,
      user_token: me.item.user.token,
      data: newDate.format("YYYY-MM-DD"),
      ora: hour,
      ora_fine: dayjs(newDate.format("YYYY-MM-DD") + " " + hour)
        .add(1, "hour")
        .format("HH:mm"),
      titolo_argomento: "",
      descrizione: "",
      id_material: null,
    });
  };

  return (
    <div>
      <header className={"flex flex-col items-center"}>
        <p className={"!text-secondary text-2xl font-semibold"}>
          Do you want to confirm?
        </p>
        <p className="text-14px text-primary">
          An event will be created in your&nbsp;
          <b className="text-secondary">Agenda</b>
        </p>
      </header>
      <div className={"flex flex-col justify-center h-full gap-y-10 mb-5"}>
        <div className=" flex flex-row items-center justify-center w-full gap-10">
          <CalendarIllustration
            className="w-[135px] h-[135px] rounded-md"
            header={dayjs(date).format("ddd")}
            day={dayjs(date).format("DD")}
            month={dayjs(date).format("MMM")}
          />
          <div className="flex flex-col items-start gap-4">
            <div className={" gap-0 flex-col items-start"}>
              <h5 className={"font-semibold"}>Time</h5>
              <p className={"text-3xl font-semibold text-brand-secondary"}>
                {hour}
              </p>
            </div>
            <div className={"detail gap-0  flex-col items-start large"}>
              <h5 className={"font-semibold"}>Duration</h5>
              <p className={"text-3xl font-semibold text-brand-secondary"}>
                1&nbsp;hour
              </p>
            </div>
          </div>
        </div>

        <footer className={"mb-6"}>
          <div className=" w-full justify-center flex flex-row gap-6">
            <Button
              variant={"outline"}
              onClick={() => {
                closeModal();
              }}
            >
              Back
            </Button>
            <Button
              onClick={() => {
                if (!date && !hour) return;
                handleConfirm();
              }}
              disabled={isLoading}
              isLoading={isLoading}
            >
              Confirm
            </Button>
          </div>
        </footer>
      </div>
    </div>
  );
}
